import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const CashInStoreDetails = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={8} xs={12}>
            Cash In Store Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper> 
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Merchant Reference Number</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["merchant_reference_number"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
              </TableBody>
            </table>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Site Reference Number</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["site_reference_number"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">{readableFormatDate(data["created_at"])}</TableBodyCell>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
